import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../hooks/useLanguage';

const Location = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-20 bg-primary-950 text-white relative overflow-hidden">
      {/* Background Blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Info */}
          <div className="w-full lg:w-1/3 space-y-8">
            <div>
              <h2 className="text-3xl md:text-5xl font-bold mb-6">{t('sections.locationTitle')}</h2>
              <p className="text-gray-300 text-lg">
                {t('location.description')}
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-white/10 p-3 rounded-lg">
                  <MapPin className="w-6 h-6 text-accent-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">{t('location.address')}</h4>
                  <p className="text-gray-400">{t('location.addressLine1')}<br/>{t('location.addressLine2')}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-white/10 p-3 rounded-lg">
                  <Phone className="w-6 h-6 text-accent-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">{t('location.phone')}</h4>
                  <p className="text-gray-400">+34 683 17 17 17</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-white/10 p-3 rounded-lg">
                  <Mail className="w-6 h-6 text-accent-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">{t('location.email')}</h4>
                  <p className="text-gray-400">info@wownautic.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-white/10 p-3 rounded-lg">
                  <Clock className="w-6 h-6 text-accent-400" />
                </div>
                <div>
                  <h4 className="font-bold text-lg">{t('location.hours')}</h4>
                  <p className="text-gray-400">{t('location.hoursValue')}</p>
                </div>
              </div>
            </div>

            <Button className="w-full bg-accent-500 hover:bg-accent-600 text-white font-bold py-6 text-lg" onClick={() => window.open('https://www.google.com/maps/place/WOW+Nautic+-+Boat+and+Jet+Ski+Rentals/@36.54217,-4.6210599,873m/data=!3m2!1e3!4b1!4m6!3m5!1s0xd72e35ca9578b3b:0xa10da4ec09350bc6!8m2!3d36.5421657!4d-4.618485!16s%2Fg%2F11xckw5k3w', '_blank')}>
              {t('location.mapButton')}
            </Button>
          </div>

          {/* Map */}
          <div className="w-full lg:w-2/3 h-[400px] lg:h-auto bg-gray-800 rounded-2xl overflow-hidden border border-white/10 shadow-2xl relative">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3199.0!2d-4.618485!3d36.5421657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72e35ca9578b3b%3A0xa10da4ec09350bc6!2sWOW%20Nautic%20-%20Boat%20and%20Jet%20Ski%20Rentals!5e0!3m2!1sen!2ses!4v1600000000000!5m2!1sen!2ses" 
              width="100%" 
              height="100%" 
              style={{ border: 0, filter: 'grayscale(0.2) contrast(1.2)' }} 
              allowFullScreen="" 
              loading="lazy"
              title="Location Map"
            ></iframe>
            
            {/* Overlay for branding */}
            <div className="absolute top-4 right-4 bg-white text-primary-950 px-4 py-2 rounded-lg shadow-lg font-bold text-sm pointer-events-none">
              📍 Fuengirola Marina
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
